import React, { useState, useEffect, useRef } from "react";
import { Button, Input, Spinner } from "reactstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import "./Home.css"; // Importando o CSS
import api from "api";
import AppModal from "components/ui/AppModal/AppModal";

const Home = ({ token }) => {
  const [isVisible] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [initialView, setInitialView] = useState(true);
  const [buttonData, setButtonData] = useState(null);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });

  const chatEndRef = useRef(null);
  const location = useLocation();

  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatMessages]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const question = params.get("question");

    if (question) {
      handleSendMessage(question);
    }
  }, [location.search]);

  const handleSendMessage = async (presetMessage = null) => {
    const message = presetMessage || userMessage;

    if (typeof message !== "string" || !message.trim()) {
      return;
    }

    const newMessage = { sender: "user", text: message };
    setChatMessages([...chatMessages, newMessage]);
    setUserMessage("");
    setLoading(true);
    setInitialView(false);

    try {
      const response = await api.post(
        `/gpt4d/chat`,
        { message },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const botMessage = { sender: "bot", text: response.data.response };
      setChatMessages(prevMessages => [...prevMessages, botMessage]);

      if (response.data.button) {
        setButtonData(response.data.button);
      } else {
        setButtonData(null);
      }

      setError(null);
    } catch (err) {
      setError("Erro ao obter resposta. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleButtonClick = async () => {
    setLoading(true);
    try {
      const response = await api.post(
        "/gpt4d/request-quote",
        {}, // Corpo da requisição vazio
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setFeedbackModal({
        open: true,
        variant: "success",
        title: "Solicitação enviada",
        message: "Sua solicitação de cotação foi enviada com sucesso!",
        confirmText: "OK"
      });

      setError(null);
    } catch (err) {
      setError("Erro ao obter resposta. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="d-flex flex-column"
        style={{ height: "100%" }}
      >
        <div>
          <h3 className="mb-4 text-center">Bem-vindo à Vertex 4D</h3>
          <hr className="m-0" />
        </div>

        <div className="d-flex flex-column justify-content-between h-100 w-100 overflow-auto bg-variante-home rounded mt-10">
          <div>
            {initialView && (
              <>
                {isVisible && (
                  <div className="d-flex flex-wrap rounded">
                    <div className="p-4">
                      <h5 className="mb-5">O que é o Vertex 4D?</h5>
                      <p
                        className="text-muted text-justify"
                        style={{ fontSize: "1em" }}
                      >
                        A Vertex 4D é uma plataforma de visualização e
                        compartilhamento da realidade capturada, voltada para
                        engenheiros, gestores de obras, arquitetos, geólogos,
                        topógrafos, empresas e pilotos de drones, entre outros.
                        Com a Vertex 4D, você pode visualizar instantaneamente
                        fotos 360 em tour virtual, filmagens e modelos 3D em
                        nuvem de pontos e objetos, de forma acionável. Além
                        disso, é possível gerar anotações através de views
                        direto na plataforma e compartilhar relatórios de
                        observações com clientes e parceiros de projetos.
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}

            {!initialView && (
              <div className="chat-box mt-10 p-3 bg-white rounded overflow-auto">
                {chatMessages.map((msg, index) => (
                  <div
                    key={index}
                    className={`message-box rounded p-3 m-2 ${
                      msg.sender === "user"
                        ? "bg-light"
                        : "bg-secondary text-white"
                    }`}
                  >
                    {msg.sender === "user" ? (
                      <p className="fw-bold">{msg.text}</p>
                    ) : (
                      <p>{msg.text}</p>
                    )}
                  </div>
                ))}
                {loading && (
                  <div className="d-flex justify-content-center">
                    <Spinner color="primary" />
                  </div>
                )}
                {error && <p className="text-danger text-center">{error}</p>}
                <div ref={chatEndRef} />

                {buttonData && (
                  <div className="text-center mt-3">
                    <Button
                      className="custom-button-chatbot rounded-pill m-1"
                      color="white"
                      onClick={handleButtonClick}
                    >
                      {buttonData.text || "Solicitar Cotação"}
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>

          <div>
            {initialView && (
              <div className="d-flex flex-column justify-content-center mx-2">
                <div className="d-flex justify-content-center mb-15">
                  <h5>
                    <strong>Como posso ajudar?</strong>
                  </h5>
                </div>

                <div className="d-flex justify-content-center mx-2">
                  <div className="d-flex flex-wrap justify-content-center">
                    {/* <Button
                      className="d-flex justify-content-center align-items-center custom-button-chatbot rounded-pill m-1"
                      color="white"
                      onClick={() =>
                        handleSendMessage(
                          "Explique melhor do que se trata tour 360."
                        )
                      }
                    >
                      <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <i className="fas fa-vr-cardboard px-2"></i>
                        <a>Tour 360</a>
                      </div>
                    </Button> */}

                    <Button
                      className="d-flex justify-content-center align-items-center custom-button-chatbot rounded-pill m-1"
                      color="white"
                      onClick={() =>
                        handleSendMessage(
                          "Me explique melhor do que se trata gêmeo digital."
                        )
                      }
                    >
                      <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <i className="fas fa-project-diagram px-2"></i>
                        <button
                          type="button"
                          onClick={() =>
                            handleSendMessage(
                              "Me explique melhor do que se trata gêmeo digital."
                            )
                          }
                          style={{
                            background: "none",
                            border: "none",
                            color: "inherit",
                            textDecoration: "underline",
                            cursor: "pointer",
                            padding: 0
                          }}
                        >
                          Gêmeo Digital
                        </button>
                      </div>
                    </Button>

                    {/*
                    <Button
                      className="d-flex justify-content-center align-items-center custom-button-chatbot rounded-pill m-1"
                      color="white"
                      onClick={() =>
                        handleSendMessage(
                          "Liste todas as soluções da Vertex 4D que utiliza IA e de que forma."
                        )
                      }
                    >
                      <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <i className="fas fa-robot px-2"></i>
                        <a>Soluções com IA</a>
                      </div>
                    </Button>
                    */}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="mt-4 d-flex justify-content-end align-items-center mx-4 mb-15">
            <Input
              type="textarea"
              value={userMessage}
              onChange={e => {
                setUserMessage(e.target.value);
                e.target.style.height = "auto";
                e.target.style.height = `${e.target.scrollHeight}px`;
              }}
              className="form-control me-2 shadow rounded-pill"
              placeholder="Descreva seus interesses ou dúvidas"
              rows="1"
              style={{
                resize: "none",
                overflow: "auto",
                maxHeight: "50px"
              }}
              onKeyPress={e => e.key === "Enter" && handleSendMessage()}
            />

            <Button
              className="ms-2 custom-button-enter"
              color="transparent"
              onClick={() => handleSendMessage()}
            >
              <i className="fas fa-paper-plane"></i>
            </Button>
          </div>
        </div>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={() => setFeedbackModal(prev => ({ ...prev, open: false }))}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={() => setFeedbackModal(prev => ({ ...prev, open: false }))}
        onCancel={() => setFeedbackModal(prev => ({ ...prev, open: false }))}
      />
    </>
  );
};

const mapStateToProps = state => ({
  token: state.auth.accessToken
});

export default connect(mapStateToProps)(Home);
